import { useEffect } from 'react'

import { init as engagementInit } from '@amplitude/engagement-browser'

interface AmplitudeEngagementProps {
    apiKey: string
}

export function useAmplitudeEngagement({
    apiKey,
}: AmplitudeEngagementProps): void {
    useEffect(() => {
        if (window.analytics && apiKey) {
            engagementInit(apiKey, { serverZone: 'US' })
            window.analytics.ready(async () => {
                await window.engagement?.boot({
                    user: {
                        user_id: window.analytics.user().id(),
                        device_id: window.analytics.user().anonymousId(),
                        user_properties: {},
                    },
                    integrations: [
                        {
                            track: (event: {
                                event_type: string
                                event_properties: Record<string, any>
                            }) => {
                                window.analytics.track(
                                    event.event_type,
                                    event.event_properties
                                )
                            },
                        },
                    ],
                })
                window.analytics.on(
                    'track',
                    (
                        event: string,
                        properties: Record<string, any>,
                        _options: any
                    ) => {
                        window.engagement?.forwardEvent({
                            event_type: event,
                            event_properties: properties,
                        })
                    }
                )
                window.analytics.on(
                    'page',
                    (
                        event: string,
                        properties: Record<string, any>,
                        _options: any
                    ) => {
                        window.engagement?.forwardEvent({
                            event_type: event,
                            event_properties: properties,
                        })
                    }
                )
            })
        }
    }, [apiKey])
}
